module.exports = __webpack_public_path__ + "img/Foto_MilchtechnEFZ-RW-MS-6227_2019.b575f057.jpg";